window.portalModule.directive "appointmentStatus", ['$log', '$filter', ($log, $filter) ->
  restrict: "E"
  scope:
    feedItem: '='
  link: (scope, element, attrs) ->

    scope.status = scope.feedItem.getDetails()

  templateUrl: 'portal/appointments/feed-items/appointment-status/appointment-status-directive-template.html'
]